//get prams from url
function getPrams(name) {
	var url = window.location.href;
	var params = url.split("?");
	if (params.length == 1) {
		return null;
	}
	var prams = params[1].split("&");
	for (var i = 0; i < prams.length; i++) {
		var param = prams[i].split("=");
		if (param[0] == name) {
			return param[1];
		}
	}
	return null;
}

//export the functions
module.exports = { getPrams };
